import React from 'react';
import { AircraftType } from '../../types';
import AircraftManager from '../AircraftManager';

type FleetTabProps = {
  aircrafts: AircraftType[];
  setAircrafts: (a: AircraftType[]) => void;
};

export const FleetTab: React.FC<FleetTabProps> = ({ aircrafts, setAircrafts }) => (
  <AircraftManager aircrafts={aircrafts} setAircrafts={setAircrafts} />
);
